import { render, staticRenderFns } from "./GridResumenCobertura.vue?vue&type=template&id=d67ebe4e&"
import script from "./GridResumenCobertura.vue?vue&type=script&lang=js&"
export * from "./GridResumenCobertura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports